export default __webpack_public_path__ + "static/media/msf_background_l1.181eb88b.jpg";